import { $, $1 } from '../utilities/selector';
import LoadManager, { QUEUE } from './load-manager';

class SocialShare {
  constructor() {
    this.el = $1('[data-js~=social-share]');
    this.buttons = [...$('[data-js~=social-share-btn]', this.el)];
    this.windowHeight = 490;
    this.windowWidth = 655;

    if (!this.el) return false;

    LoadManager.queue(this.init.bind(this), QUEUE.RESOURCES);
  }

  init() {
    this.bind();
  }

  bind() {
    this.buttons.map(el => {
      el.addEventListener('click', (e) => {
        this.popupClick(el);
      });
    });

  }

  popupClick(e) {
    event.preventDefault();
    this.windowUrl = e.getAttribute("href");
    this.windowName = e.getAttribute("data-share");

    window.open(this.windowUrl, this.windowName, 'width=' + this.windowWidth + ',height=' + this.windowHeight);
  }

}

export default LoadManager.queue(() => new SocialShare(), QUEUE.DOM);



// WEBPACK FOOTER //
// ./scripts/components/social.js